import React from 'react';
import { Typography, Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import theme from 'themes/theme'
import SubscribeToView from 'components/Common/SubscribeToView'
// import { useSelector } from 'react-redux'

const FreeUser = () => {
  return (
    <>
      <Box display="flex" alignItems="flex-start">
        <Typography className="py-1" variant="body2">
          Business Credit Risk Score<sup>TM</sup>: &nbsp;
          <SubscribeToView />
        </Typography>
      </Box>
      <Box display="flex" alignItems="flex-start">
        <Typography className="py-1" variant="body2">
          Business Credit Risk Class<sup>TM</sup>: &nbsp;
          <SubscribeToView />
        </Typography>
      </Box>
    </>
  )
}
const CRCText = ({ value }) => {
  return (
    <>
      <span style={{ color: theme.palette.color.blueLight }}>
        <b>{value}</b>
      </span>{' '}
      of 660
    </>
  )
}

const HealthMetricsComponent = ({ data, isFreeAccount }) => {
  const theme = useTheme()
  let creditClassData = data.crc
  let colors =
    creditClassData >= 4
      ? theme.palette.color.negative
      : creditClassData <= 2
      ? theme.palette.color.aqua110
      : theme.palette.color.blueLight

  const { details } = data
  // const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const showClaimed = !isFreeAccount 

  const displayedFields = details.displayedFields
    ? details.displayedFields
    : {
        corpEmp: true,
        creditClass: true,
        creditScore: true,
        foreign: true,
        legalName: true,
        legalSubParentName: true,
        localEmp: true,
        public: true,
        revenueCorporate: true,
        revenueLocal: true,
      }
  return (
    <Box display={'flex'} gap="7px" alignItems="baseline">
      <Box display="flex" flexDirection="column">
        {showClaimed ? (
          <>
            <Box display="flex" alignItems="center" marginBottom="20px">
              <Typography className="py-1" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                Business Credit Risk Score<sup>TM</sup>: &nbsp;
                {details.crs && displayedFields.creditScore ? (
                  <CRCText value={details.crs} />
                ) : (
                  <span
                    style={{
                      color: '#BDBDCE',
                      fontSize: '20px',
                      lineHeight: '30px',
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                    }}
                  >
                    NA
                  </span>
                )}
                &nbsp;
              </Typography>
            </Box>
            <Box marginTop={displayedFields.creditScore ? '-20px' : 0} display="flex" alignItems="center">
              <Typography className="py-1" variant="body2">
                Business Credit Risk Class<sup>TM</sup>: &nbsp;
                {details.crc && displayedFields.creditClass ? (
                  <span style={{ color: colors }}>
                    <b>{details.crc}</b>
                  </span>
                ) : (
                  <span
                    style={{
                      color: '#BDBDCE',
                      fontSize: '20px',
                      lineHeight: '30px',
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                    }}
                  >
                    NA
                  </span>
                )}
                &nbsp;
              </Typography>
            </Box>
          </>
        ) : (
          <FreeUser data={data} />
        )}
      </Box>
    </Box>
  )
}

export default HealthMetricsComponent;